import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Divider, Drawer, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import CarrierServiceFilterPopover from "../PopOvers/CarrierServicesFilterPopover";
// Static carrier data
const staticCarrierData = {
    ats: [
        "Amazon Shipping Express (Ground) - Forward",
        "Amazon Shipping Express (Ground) - Reverse",
        "Amazon Shipping Air - Reverse",
        "Amazon Shipping Air - Forward",
        "Amazon Shipping Standard",
    ],
    delhivery: ["Express", "Surface", "Surface 250gm"],
    bluedart: ["Surface 1.5kg", "Air", "Surface"],
    dtdc: ["B2C SMART EXPRESS", "B2C PRIORITY"],
    "dtdc-b2b": [
        "EXPRESS",
        "SURFACE EXPRESS",
        "STANDARD_AIR",
        "AIR CARGO",
        "GROUND_EXPRESS",
        "COD",
        "PRIORITY",
        "B2C SMART EXPRESS",
        "B2C PRIORITY",
        "SURFACE ECONOMY",
        "B2B SMART EXPRESS",
    ],
    ecom: ["Express"],
    xpressbees: [
        "Xpressbees 5 K.G",
        "Xpressbees Same Day Delivery",
        "Surface Xpressbees 0.5 K.G",
        "Express Reverse",
        "Air Xpressbees 0.5 K.G",
        "Xpressbees 10 K.G",
        "Xpressbees 1 K.G",
        "Xpressbees Next Day Delivery",
        "Xpressbees 2 K.G",
    ],
    zippyybluedart: ["Plus Surface", "Air", "Surface"],
    ekart: [
        "EKART_REPLACEMENT",
        "PREMIUM",
        "RETURNS_CLOSED_BOX",
        "DIRECT_DH_DELIVERED",
        "NDD",
        "REGULAR",
        "INBOUND",
        "SDD",
        "EXPRESS",
        "PREXO",
        "RETURN_INVENTORIZE",
        "RETURNS_SMART_CHECK",
        "ECONOMY",
        "RETURNS_BASIC_CHECK",
        "PICKUP_AND_DELIVER",
    ],
};
const DisputeFilterDrawer = ({ isFilterDrawerOpen, handleFilterClose, setOrderNumbersStrP, setAWBstrP, selectedServicesP, setSelectedCarriersP, selectedCarriersP, setSelectedServicesP, orderNumbersStrP, AWBstrP, }) => {
    const [carrierServicesList, setCarrierServicesList] = React.useState(staticCarrierData);
    const [orderNumbersStr, setOrderNumbersStr] = React.useState(orderNumbersStrP);
    const [AWBstr, setAWBstr] = React.useState(AWBstrP);
    const [carrierServices, setCarrierServices] = React.useState({});
    const [carrierServiceAnchorEl, setCarrierServiceAnchorEl] = useState(null);
    const handleCarrierServiceClose = () => {
        setCarrierServiceAnchorEl(null);
    };
    const handleCarrierServiceClick = (event) => {
        setCarrierServiceAnchorEl(event.currentTarget);
    };
    const handleReset = () => {
        setOrderNumbersStrP("");
        setAWBstrP("");
        setSelectedCarriersP(null);
        setSelectedServicesP(null);
        setOrderNumbersStr("");
        setAWBstr("");
        setCarrierServices({});
    };
    const handleSaveClick = () => {
        setOrderNumbersStrP(orderNumbersStr);
        setAWBstrP(AWBstr);
        const selectedCarriers = Object.keys(carrierServices).join(",");
        const selectedServices = Array.from(new Set(Object.values(carrierServices).flat())).join(",");
        setSelectedCarriersP(selectedCarriers);
        setSelectedServicesP(selectedServices);
        handleFilterClose();
    };
    const extractCarriers = () => {
        const selectedCarriers = Object.keys(carrierServices).join(",");
        return selectedCarriers;
    };
    const extractServices = () => {
        const selectedServices = Array.from(new Set(Object.values(carrierServices).flat())).join(",");
        return selectedServices;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { anchor: "right", open: isFilterDrawerOpen, onClose: handleFilterClose },
            React.createElement(Grid, { container: true, direction: "column", sx: { width: 500, p: 2 } },
                React.createElement(Grid, { item: true, container: true, justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Typography, { variant: "subtitle1" }, "Filter"),
                    React.createElement(IconButton, { onClick: handleFilterClose },
                        React.createElement(CloseIcon, null))),
                React.createElement(Divider, null),
                React.createElement(Grid, { item: true, container: true, direction: "row", sx: { mt: 3, mb: 3 } },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Carrier & Service"),
                        React.createElement(TextField, { InputProps: {
                                endAdornment: (React.createElement(InputAdornment, { position: "end" }, carrierServiceAnchorEl ? React.createElement(ArrowDropUpIcon, null) : React.createElement(ArrowDropDownIcon, null))),
                            }, "aria-readonly": true, sx: { mb: 2 }, value: extractCarriers()
                                ? `${extractCarriers()}-${extractServices()}`
                                : selectedCarriersP || selectedServicesP
                                    ? `${selectedCarriersP}-${selectedServicesP}`
                                    : "", size: "small", fullWidth: true, onClick: (e) => handleCarrierServiceClick(e) })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Enter multiple order numbers"),
                        React.createElement(TextField, { "aria-readonly": true, sx: { mb: 2 }, value: orderNumbersStr, size: "small", fullWidth: true, onChange: (e) => setOrderNumbersStr(e.target.value), placeholder: "Enter upto 200 order numbers separated by comma" })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "m_form_label_font", variant: "body2", gutterBottom: true }, "Enter multiple AWBs"),
                        React.createElement(TextField, { "aria-readonly": true, sx: { mb: 2 }, value: AWBstr, size: "small", fullWidth: true, onChange: (e) => setAWBstr(e.target.value), placeholder: "Enter AWBs. Use comma as separator 1001, 1002" }))),
                React.createElement(Grid, { item: true, container: true, justifyContent: "space-between", sx: { mt: 3 } },
                    React.createElement(Button, { variant: "outlined", onClick: handleReset, sx: { textTransform: "none", color: "#121114", borderColor: "#121114" } }, "Reset all"),
                    React.createElement(Button, { variant: "contained", onClick: handleSaveClick, sx: { textTransform: "none" } }, "Apply"))),
            carrierServiceAnchorEl && carrierServicesList && (React.createElement(CarrierServiceFilterPopover, { carrierData: carrierServicesList, anchorEl: carrierServiceAnchorEl, handleClose: handleCarrierServiceClose, carrierServices: carrierServices, setCarrierServices: setCarrierServices })))));
};
export default DisputeFilterDrawer;
